import React from 'react';
import PasswordRule from './PasswordRule';
import entries from 'object.entries';
import PropTypes from 'prop-types';

const propTypes = {
    showStatus: PropTypes.bool.isRequired,
    rulesStatus: PropTypes.arrayOf(PropTypes.object)
};

const rules = {
    0: 'Uppercase letters',
    1: 'Lowercase letters',
    2: 'At least 1 number',
    3: 'At least 1 special character'
};

function PasswordRules(props) {
    if (!Object.entries) {
        entries.shim();
    }

    let rulesElems = props.rulesStatus.map(ruleObj => {
        const key = ruleObj.rule;
        const value = rules[key];
        const isSatisfied = ruleObj.isSatisfied;
        return (
            <PasswordRule
                key={key}
                rule={value}
                isSatisfied={isSatisfied}
                showStatus={props.showStatus}
            />
        );
    });

    return (
        <div className="mfa-rules-list">
            <ul>{rulesElems}</ul>
        </div>
    );
}

PasswordRules.propTypes = propTypes;

export default PasswordRules;
